// extracted by mini-css-extract-plugin
module.exports = {"main":"RichText_main__L_7T3","richTextIframe":"RichText_richTextIframe__sid0P","richTextImg":"RichText_richTextImg__kXSvA"};